export default "__VITE_ASSET__CMZFMLm7__"